import { api_GET, api_POST, api_PUT } from './_api';

const destinacaoColeta_api = {
    GetList: (tipo) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`DestinacaoColeta/GetList/${tipo}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetVeiculoSemRegistro: (placa) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`DestinacaoColeta/GetVeiculoSemRegistro/${placa}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetModalidades: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`DestinacaoColeta/GetModalidades/`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    AtualizarDestinacao: (tipo, model) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`DestinacaoColeta/AtualizarDestinacao/${tipo}`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    InsertEntradaAvulsa: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`DestinacaoColeta/EntradaAvulsa/`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    RecusaOrdem: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`DestinacaoColeta/RecusaOrdem/`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    ListDestinacaoManutencao: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`DestinacaoColeta/ListDestinacaoManutencao`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    InsertDestinacaoManutencao: (model) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`DestinacaoColeta/InsertDestinacaoManutencao`, model)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default destinacaoColeta_api;